import axios from 'axios';
import { toast } from 'react-toastify';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const authenticatedApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL ,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const authenticatedFormDataApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL ,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  },
});

export const formDataApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL ,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  },
});

// Auth0 token getter
let auth0TokenGetter: (() => Promise<string | null>) | null = null;

export const setAuth0TokenGetter = (tokenGetter: () => Promise<string | null>) => {
  auth0TokenGetter = tokenGetter;
};

// Request interceptor to add Auth0 token
async function requestInterceptorFunction(config: any): Promise<any> {
  if (auth0TokenGetter) {
    try {
      const token = await auth0TokenGetter();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Failed to get Auth0 token:', error);
    }
  }
  return config;
}

function responseInterceptorFunction(response: any): any {
  return response;
}

function responseInterceptorErrorFunction(error: any) {
  const originalRequest = error.config;

  // Handle 429 Too Many Requests with exponential backoff
  if (error.response?.status === 429 && (!originalRequest._retryCount || originalRequest._retryCount < 3)) {
    originalRequest._retryCount = (originalRequest._retryCount || 0) + 1;
    const delay = Math.pow(2, originalRequest._retryCount) * 1000;

    return new Promise(resolve => {
      setTimeout(() => {
        resolve(axios(originalRequest));
      }, delay);
    });
  }

  // For Auth0, 401/403 means token expired or invalid - redirect to login
  if (error.response?.status === 401 || error.response?.status === 403) {
    toast.error('Session expired. Please log in again.');
    window.location.href = '/';
    return Promise.reject(error);
  }

  return Promise.reject(error);
}

// Add interceptors for authenticated APIs
authenticatedFormDataApi.interceptors.request.use(requestInterceptorFunction);
authenticatedApi.interceptors.request.use(requestInterceptorFunction);
authenticatedFormDataApi.interceptors.response.use(responseInterceptorFunction, responseInterceptorErrorFunction);
authenticatedApi.interceptors.response.use(responseInterceptorFunction, responseInterceptorErrorFunction);